const crudPrefix = process.env.VUE_APP_CRUD_PREFIX || 'crud-service';
const geocodingPrefix = process.env.VUE_APP_GEOCODING_PREFIX || 'geocoding-service';
const planningPrefix = process.env.VUE_APP_PLANNING_PREFIX || 'planning-service';
const tracingPrefix = process.env.VUE_APP_TRACING_PREFIX || 'tracing-service';
const mobilePrefix = process.env.VUE_APP_MOBILE_PREFIX || 'mobile-service';
const transportPrefix = process.env.VUE_APP_TRANSPORT_PREFIX || 'tm-service';
const locationPrefix = process.env.VUE_APP_LOCATION_PREFIX || 'location-service';
const logisticToolkitPrefix = 'login-toolkit-service';
const baseApiUrl = process.env.VUE_APP_BASE_API_URL || 'https://geosort.falabella.com/api/';

const joinUrl = (baseUrl, uri) => `${baseUrl.replace(/\/?$/, '/')}${uri.replace(/^\//, '')}`;
const isAbsoluteUrl = uri => /^https?:\/\//.test(uri);

let url;
// eslint-disable-next-line prefer-const
url = {
  baseurl: baseApiUrl,
  baseurl_dev: process.env.VUE_APP_BASE_API_URL_DEV,
  imports_do: {
    upload_xlsx: {
      method: 'post',
      uri: () => `${geocodingPrefix}/v1/web/uploading`,
    },
  },
  location: {
    suborder_locations_edit: {
      method: 'post',
      uri: () => `${locationPrefix}/v1/suborder_locations/edit`,
    },
    find_route: {
      method: 'post',
      uri: () => `${locationPrefix}/v1/route`,
    },
    change_status: {
      method: 'post',
      uri: () => `${locationPrefix}/v1/suborders`,
    },
    reasons: {
      method: 'get',
      uri: () => `${locationPrefix}/v1/reasons`,
    },
  },
  toolkit: {
    audit_node_configuration: {
      method: 'post',
      uri: () => `${logisticToolkitPrefix}/order-actions/audit`,
    },
    visitCreation: {
      method: 'post',
      uri: () => `${logisticToolkitPrefix}/send-simpliroute-visits`,
    },
    visitCreationProgress: {
      method: 'get',
      uri: params => `${logisticToolkitPrefix}/visit-creation-progress/${params.batchId}`,
    },
    sendStateTrmg: {
      method: 'post',
      uri: () => `${logisticToolkitPrefix}/send-state-trmg`,
    },
  },
  crud: {
    login: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/login`,
    },
    register: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/register`,
    },
    registerV2: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/register2`,
    },
    register_inhouse_tren_logistico: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/accounts/inhouse-tren-logistico`,
    },
    verify_driver_data: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/user/driver_data`,
    },
    get_list_accounts: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/accounts_filter`,
    },
    update_accounts: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/toggle_account`,
    },
    get_accounts: { // este
      method: 'get',
      uri: () => `${crudPrefix}/v1/accounts`,
    },
    get_inhouse_tren_logistico_enterprises: {
      method: 'get',
      uri: pp => `${crudPrefix}/v1/accounts/inhouse-tren-logistico/${pp.id}/enterprises`,
    },
    update_inhouse_tren_logistico_enterprises: {
      method: 'patch',
      uri: pp => `${crudPrefix}/v1/accounts/inhouse-tren-logistico/${pp.id}`,
    },
    update_account: {
      method: 'put',
      uri: pp => `${crudPrefix}/v1/update_account/${pp.id}`,
    },
    delivery_methods: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/deliveryMethods`,
    },
    refresh_token: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/auth/refresh_token`,
    },
    account_info: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/auth/information`,
    },
    get_communes: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/communes`,
    },
    get_localities: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/localities`,
    },
    get_account_types: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/accountTypes`,
    },
    get_account_types_v2: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/accountTypesV2`,
    },
    get_distribution_centers: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/distributionCentersCache`,
    },
    get_distribution_centers_full: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/distributionCenters`,
    },
    update_distribution_center: {
      method: 'put',
      uri: pp => `${crudPrefix}/v1/distributionCenters/${pp.id}`,
    },
    get_distribution_center_configs: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/distributionCenterConfigs`,
    },
    update_distribution_center_configs_bulk: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/distributionCenterConfigs/bulk`,
    },
    get_enterprises: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/enterprisesCache`,
    },
    get_regions: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/regions`,
    },
    get_time_windows: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/timeWindows`,
    },
    add_time_windows: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/timeWindows`,
    },
    get_drivers: { // Este
      method: 'get',
      uri: () => `${crudPrefix}/v1/drivers`,
    },
    get_driver: {
      method: 'get',
      uri: pp => `${crudPrefix}/v1/drivers/${pp.id}`,
    },
    update_driver: {
      method: 'put',
      uri: pp => `${crudPrefix}/v1/drivers/${pp.id}`,
    },
    disassociate_driver: {
      method: 'put',
      uri: pp => `${crudPrefix}/v1/update_driver/${pp.id}`,
    },
    get_vehicles: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/vehicles`,
    },
    get_trucks: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/vehicles`,
    },
    get_logs: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/progress/all-process`,
    },
    get_zones: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/restrictionAreas`,
    },
    create_account: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/register`,
    },
    get_carriers: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/carriers`,
    },
    create_carrier: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/carriers`,
    },
    remove_carrier: {
      method: 'delete',
      uri: pp => `${crudPrefix}/v1/carriers/${pp.id}`,
    },
    deactivate_account: {
      method: 'put',
      uri: pp => `${crudPrefix}/v1/deactivate_account/${pp.id}`,
    },
    change_status_zones: {
      method: 'put',
      uri: pp => `${crudPrefix}/v1/restrictionAreas/${pp.id}`,
    },
    change_status_priority: {
      method: 'put',
      uri: pp => `${crudPrefix}/v1/priorityAreas/${pp.id}`,
    },
    delete_zone: {
      method: 'delete',
      uri: pp => `${crudPrefix}/v1/restrictionAreas/${pp.id}`,
    },
    delete_priority: {
      method: 'delete',
      uri: pp => `${crudPrefix}/v1/priorityAreas/${pp.id}`,
    },
    add_priority: {
      method: 'post',
      uri: () => `${crudPrefix}/v1/priorityAreas`,
    },
    get_priority: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/priorityAreas`,
    },
    get_time_windows_tags: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/timeWindowsTags`,
    },
    get_geo_states: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/geoStates`,
    },
  },
  // END CRUD
  geocoding: {
    get_unlocated: {
      method: 'get',
      uri: () => `${geocodingPrefix}/v1/geolocation`,
    },
    get_point_examples: {
      method: 'get',
      uri: () => `${geocodingPrefix}/v1/geolocation/subordersByPoint`,
    },
    update_location: {
      method: 'put',
      uri: pp => `${geocodingPrefix}/v1/geolocation/point/${pp.id}`,
    },
    update_location_v2: {
      method: 'put',
      uri: pp => `${geocodingPrefix}/v1/geolocation/pointV2/${pp.id}`,
    },
    suborders_request: {
      method: 'post',
      uri: () => `${geocodingPrefix}/v1/geolocation/fromSuborder`,
    },
    get_points_total: {
      method: 'get',
      uri: () => `${geocodingPrefix}/v1/geolocation/geoCounter`,
    },
    get_points: {
      method: 'get',
      uri: () => `${geocodingPrefix}/v1/geolocation/getPoints`,
    },
    get_points_total_v2: {
      method: 'get',
      uri: () => `${geocodingPrefix}/v1/geolocation/geoCounter2`,
    },
    get_points_v2: {
      method: 'get',
      uri: () => `${geocodingPrefix}/v1/geolocation/getPoints2`,
    },
    get_queue_data: {
      method: 'get',
      uri: pp => `${geocodingPrefix}/v1/redis/queue_data/${pp.id}/${pp.queue}`,
    },
  },
  planning: {
    get_patents: {
      method: 'get',
      uri: pp => `${planningPrefix}/v1/planning/vehicles/${pp.id}`,
    },
    get_routes_multiple: {
      method: 'get',
      uri: pp => `${planningPrefix}/v1/edit/${pp.id}/by-planning`,
      // uri: pp => `http://localhost:3000/geosort-prd/planning-service/v1/edit/${pp.id}/by-planning`,
    },
    // Nuevo servicio multiple
    get_routes_multiple_v2: {
      method: 'get',
      uri: pp => `${planningPrefix}/v1/edit/${pp.id}/multiple-routes`,
      // uri: pp => `http://localhost:3000/geosort-prd/planning-service/v1/edit/${pp.id}/multiple-routes`,

    },
    // Nuevo servicio multiple getSocInfo
    get_routes_soc_info: {
      method: 'get',
      uri: pp => `${planningPrefix}/v1/suborders/getSocInfo${pp.ids && pp.ids.length > 0
        ? `?${pp.ids.map(id => `route_id=${id}`).join('&')}` : ''}`,
      // uri: pp => `http://localhost:3000/geosort-prd/planning-service/v1/suborders/getSocInfo${pp.ids && pp.ids.length > 0
      // ? `?${pp.ids.map(id => `route_id=${id}`).join('&')}` : ''}`,
    },
    get_routes_id: {
      method: 'get',
      uri: pp => `${planningPrefix}/v1/edit/${pp.id}/routes-id`,
    },
    send_form: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning`,
    },
    replanning_status: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/replanning_status`,
    },
    unlink_driver: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/unlink-driver`,
    },
    planning_with_soc_list: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/v2`,
    },
    planning_v4: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/v4`,
    },
    planning_collaborative: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/collaborative`,
    },
    add_zone: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/division`,
    },
    adm_suborden: {
      method: 'put',
      uri: () => `${planningPrefix}/v1/suborders`,
    },
    socs_to_centroide: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/suborders/free-points`,
    },
    addanddelete_suborders: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}`,
    },
    /*
      trl_id: {
        method: 'post',
        uri: pp => `${planningPrefix}/v1/routes/${pp.id}/trl`,
      },
       */
    get_pre_report: {
      method: 'get',
      uri: id => `${planningPrefix}/v1/download-planning/${id}`,
    },
    suborders_routes: {
      method: 'get',
      uri: () => `${planningPrefix}/v1/suborders`,
    },
    config_planning: {
      method: 'get',
      uri: () => `${planningPrefix}/v1/planning/config`,
    },
    config_planning_create: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/config`,
    },
    config_planning_delete: {
      method: 'delete',
      uri: id => `${planningPrefix}/v1/planning/config/${id}`,
    },
    // ADVANCED PLANNING CONFIG
    get_advanced_configs_planning: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/config_advanced`,
    },
    create_advanced_config_planning: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/config_advanced`,
    },
    delete_advanced_config_planning: {
      method: 'delete',
      uri: id => `${planningPrefix}/v1/planning/config_advanced/${id}`,
    },
    adm_routes: { // Modify Routes
      method: 'get',
      uri: () => `${planningPrefix}/v1/routes`,
    },
    status_planning: {
      method: 'get',
      uri: () => `${planningPrefix}/v1/planning`,
    },
    manage_routes: { // No lo he ocupado
      method: 'put',
      uri: () => `${planningPrefix}/v1/planning`,
    },
    planning: { // No lo he ocupado
      method: 'get',
      uri: () => `${planningPrefix}/v1/planning`,
    },
    suborders_planning: {
      method: 'get',
      uri: () => `${planningPrefix}/v1/suborders`,
    },
    distribution_centers: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/distributionCentersCache`,
    },
    statuses_planning: { // Ya no se usa
      method: 'get',
      uri: () => `${crudPrefix}/v1/planningStatuses`,
    },
    regions: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/regions`,
    },
    enterprises: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/enterprisesCache`,
    },
    communes: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/communes`,
    },
    document_type: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/documentTypesCache`,
    },
    package_types: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/packageTypes`,
    },
    travel_types: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/travelTypes`,
    },
    transfer_center: {
      method: 'get',
      uri: () => `${crudPrefix}/v1/transferCentersCache`,
    },
    set_vehicle_on_route: {
      method: 'post',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/vehicle`,
    },
    set_vehicle_on_routev2: {
      method: 'post',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/vehicleV2`,
    },
    set_vehicle_on_routev3: {
      method: 'post',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/vehicleV3`,
    },
    activate_route: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/activate`,
    },
    confirm_shipment_route: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/confirm_shipment`,
    },
    deactivate_route: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/deactivate`,
    },
    deactivate_route_v2: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/deactivate/v2`,
    },
    replanning_route: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/replanning/v4`,
    },
    planning_rollback: {
      method: 'delete',
      uri: pp => `${planningPrefix}/v1/planning/rollback/${pp.id}`,
    },
    get_routes: {
      method: 'get',
      uri: () => `${planningPrefix}/v1/routes`,
    },
    filter_soc_to_planning: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/suborders`,
    },
    verify_suborders: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/suborders/verify`,
    },
    verify_suborders_v2: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/suborders/verify/v2`,
    },
    verify_lpn: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/lpn/verify`,
    },
    get_to: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/suborders/to`,
    },
    get_route_by_id: {
      method: 'get',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}`,
    },
    search_state_orders: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/suborders/state-orders/search`,
    },
    change_route_distribution_center: {
      method: 'put',
      uri: pp => `${planningPrefix}/v1/routes/${pp.id}/distribution-center`,
    },
    change_route_locality: {
      method: 'put',
      uri: () => `${planningPrefix}/v1/routes/locality`,
    },
    get_route_locality_orders: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/routes/locality/orders`,
    },
    get_suborders_box: {
      method: 'post',
      uri: () => `${planningPrefix}/v1/planning/suborders/box/v2`,
    },
  },
  tracing: {
    get_suborders: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/tracing/do`,
    },
    get_resume_report: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/reporter/data`,
    },
    get_summary_geo_report: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/geo_reporter/geo_summary`,
    },
    get_report: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/reporter/download`,
    },
    get_geo_report: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/geo_reporter/geo_download`,
    },
    get_routes_tracing: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/tracing/routes`,
    },
    get_tracing_data: {
      method: 'get',
      uri: pp => `${tracingPrefix}/v1/metrics/tracing/data${pp.id}`,
    },
    enterprises: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/metrics/tracing/progress`,
    },
    ns: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/metrics/ns`,
    },
    vehicle: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/metrics/tracing/vehicle`,
    },
    customer: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/metrics/tracing/customer`,
    },
    suborder: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/metrics/tracing/suborder`,
    },
    drivers: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/management/getdrivers`,
    },
    vehicles: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/management/getvehicles`,
    },
    toggle_vehicle: {
      method: 'post',
      uri: () => `${tracingPrefix}/v1/management/togglevehicle`,
    },
    toggle_driver: {
      method: 'post',
      uri: () => `${tracingPrefix}/v1/management/toggledriver`,
    },
    // NEW VIEW TRACING
    enterprises_active_one: {
      method: 'get',
      uri: pp => `${tracingPrefix}/v1/tracing/routes/today/${pp.id}`,
    },
    enterprises_active_ent: {
      method: 'get',
      uri: pp => `${tracingPrefix}/v1/tracing/routes/today/${pp.id}/enterprise`,
    },
    enterprises_tracking: {
      method: 'post',
      uri: () => `${tracingPrefix}/v1/tracing/routes/today`,
    },
    enterprises_active_routes: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/metrics/activeRoutes`,
    },
    get_active_routes: {
      method: 'get',
      uri: () => `${tracingPrefix}/v1/tracing/routes/today`,
    },
  },
  mobile: {
    retry_route_association_event: {
      method: 'post',
      uri: pp => `${mobilePrefix}/v1/mobile/retry/association/${pp.id}/update-event`,
    },
    retry_route_association_update_event: {
      method: 'post',
      uri: pp => `${mobilePrefix}/v1/mobile/retry/association/${pp.id}/update-event`,
    },
  },
  transport: {
    get_vehicles: {
      method: 'get',
      uri: () => `${transportPrefix}/v1/vehicles`,
    },
  },
};

// eslint-disable-next-line import/prefer-default-export,func-names
export const getUrl = function (module, service, pathparam = {}) {
  const uri = url[module][service].uri(pathparam);

  return {
    route: isAbsoluteUrl(uri) ? uri : joinUrl(url.baseurl, uri),
    method: url[module][service].method,
  };
};
